import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {restrictData} from "./Validations";

export function AGCText({
                            formik,
                            name,
                            toolTip = "",
                            id,
                            placeHolder = "",
                            value = "",
                            readOnly = false,
                            validation = [0],
                            required = true,
                        }) {

    const [inputValue, setInputValue] = useState(value);

    // Sync local state with prop value when it changes externally
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    // Debounce the formik update
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            // Only update if the value has actually changed
            if (inputValue !== value) {
                formik.setFieldValue(id, inputValue);
            }
        }, 500); // 500ms debounce

        return () => clearTimeout(timeoutId);
    }, [inputValue, id, value, formik]);

    if (toolTip === "") {
        toolTip = "Enter the " + name;
    }

    if (placeHolder === "") {
        placeHolder = "Enter the " + name;
    }

    const handleChange = (event) => {
        let val = event.target.value;
        val = restrictData(validation, val);
        setInputValue(val);
    };

    return (

        <>
            <Form.Label className={required ? "required" : ""}>{name}</Form.Label>
            <Form.Control
                id={id}
                placeholder={placeHolder}
                onChange={handleChange}
                value={inputValue}
                disabled={readOnly}
            />
            <Form.Text className="text-muted">{toolTip}</Form.Text>
        </>
    );
}
